import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static override targets = ['button', 'content', 'contentInner', 'plusIcon', 'minusIcon'];

  declare readonly buttonTargets: HTMLButtonElement[];
  declare readonly contentTargets: HTMLElement[];
  declare readonly plusIconTargets: SVGElement[];
  declare readonly minusIconTargets: SVGElement[];
  declare readonly contentInnerTargets: HTMLElement[];

  /**
   * アコーディオンを制御する
   * @param event イベント
   */
  onToggle(event: Event) {
    const button = event.currentTarget as HTMLButtonElement;
    const buttonIndex = this.buttonTargets.indexOf(button);

    if (buttonIndex === -1) return;

    const content = this.contentTargets[buttonIndex];
    const plusIcon = this.plusIconTargets[buttonIndex];
    const minusIcon = this.minusIconTargets[buttonIndex];

    if (!content || !plusIcon || !minusIcon) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    if (isExpanded) {
      this.collapse(button, content, plusIcon, minusIcon);
    } else {
      this.expand(button, content, plusIcon, minusIcon);
    }
  }

  private expand(
    button: HTMLButtonElement,
    content: HTMLElement,
    plusIcon: SVGElement,
    minusIcon: SVGElement
  ) {
    button.setAttribute('aria-expanded', 'true');

    // コンテンツの高さを計算してアニメーション（Stimulus targets を利用）
    const buttonIndex = this.buttonTargets.indexOf(button);
    const contentInner = this.contentInnerTargets[buttonIndex];
    const targetHeight = contentInner?.offsetHeight ?? 0;

    content.style.maxHeight = '0px';

    // 次のフレームでアニメーション開始
    requestAnimationFrame(() => {
      content.style.maxHeight = `${targetHeight}px`;
    });

    plusIcon.style.opacity = '0';
    minusIcon.style.opacity = '1';
  }

  private collapse(
    button: HTMLButtonElement,
    content: HTMLElement,
    plusIcon: SVGElement,
    minusIcon: SVGElement
  ) {
    button.setAttribute('aria-expanded', 'false');

    content.style.maxHeight = '0px';
    plusIcon.style.opacity = '1';
    minusIcon.style.opacity = '0';
  }
}
